module.exports = __webpack_public_path__ + "img/img5.d920fe16.jpg";